export default __webpack_public_path__ + "static/media/very-satisfied.1c520161.svg";